/**
 * Error handling middleware for Redux
 */
export const errorMiddleware = (store) => (next) => (action) => {
  try {
    return next(action);
  } catch (error) {
    console.error('Redux Error:', error);
    
    // Dispatch error action if needed
    if (action.type.includes('auth/')) {
      store.dispatch({
        type: 'auth/setError',
        payload: error.message
      });
    }
    
    throw error;
  }
};